module.exports = __webpack_public_path__ + "img/knife.bce5a463.svg";